module.exports = __webpack_public_path__ + "static/media/cdb24.7879b200.png";